import React, { useState } from "react";
import PageLayout from "../components/ui/PageLayout";
import { useQueryParams } from "../hooks/useQueryParams";
import PageCard from "../components/ui/PageCard";
import PrimaryTabs from "../components/ui/PrimaryTabs";
import CustomTable from "../components/ui/DataTable";
import Pagination from "../components/ui/Pagination";
import useFetch from "../hooks/useFetch";
import { useSelector } from "react-redux";
import { selectCid } from "../features/companyid";
import { selectCustomPagination } from "../features/paginationStore";
import {
    getInterviewColoumnFromType,
  getPageKeyAndNumber,
  getUrlFromInterviewCreditFilters,
} from "../utils/interviewCredit/interviewCreditUtils";
import { FILTERSKEY, LIST_TYPES } from "../constants/interviewCreditConstants";
import { firstOfEveryMonth, formatDateToISOCustom } from "../utils/dateUtils";
import DatePickerWithoutStore from "../components/ui/DatePickerWithoutStore";
import download_black from "../images/download_balck.png"
import ExportCSV from "../components/ui/ExportCSV";

const InterviewCredit = () => {
  const { query } = useQueryParams();
  const { type = LIST_TYPES.RAW } = query;
  const cid = useSelector(selectCid);
const [startDateFilterKey, setStartDateFilterKey] = useState({
  [LIST_TYPES.RAW]: firstOfEveryMonth(new Date()),
  [LIST_TYPES.MONTHLY]: firstOfEveryMonth(new Date()),
  [LIST_TYPES.DAILY]: firstOfEveryMonth(new Date()),
});

const [endDateFilterKey, setEndDateFilterKey] = useState({
  [LIST_TYPES.RAW]: formatDateToISOCustom(new Date()),
  [LIST_TYPES.MONTHLY]: formatDateToISOCustom(new Date()),
  [LIST_TYPES.DAILY]: formatDateToISOCustom(new Date()),
});

  const pages = useSelector((state) =>
    selectCustomPagination(state, getPageKeyAndNumber(type)+startDateFilterKey[type]+endDateFilterKey[type])
  );

  const { data = { data: [] }, isLoading } = useFetch(
    `/v2/applicant/interviewstats?companyid=${cid}&type=${type}&page=${
      pages.page
    }&page_size=${pages.page_size}${getUrlFromInterviewCreditFilters({
      from: startDateFilterKey[type],
      to: endDateFilterKey[type],
    })}`,
    {
      method: "POST",
    }
  );

  const { refetch } = useFetch(`/v2/applicant/interviewstats?companyid=${cid}&type=${type}&page=-1${getUrlFromInterviewCreditFilters({
      from: startDateFilterKey[type],
      to: endDateFilterKey[type],
    })}`,
    {
      method: "POST",
    },
    false
  )

  return (
    <PageLayout title={"AI Interview Usage"} backLink={"/settings/profiles"} rightSideElements={<>
    <ExportCSV filename={`interview-usage-${type}.csv`} fetchData={refetch} buttonLabel={<img src={download_black} className="text-slate-700 cursor-pointer w-7 h-7" />} />
    </>
    }>
      <PageCard className={"!py-0"}>
        <PrimaryTabs
          tabKey="type"
          tabs={[
            { label: "Raw", value: LIST_TYPES.RAW },
            { label: "Monthly", value: LIST_TYPES.MONTHLY },
            { label: "Daily", value: LIST_TYPES.DAILY },
          ]}
        />
        <div className="">
          <CustomTable
            columns={getInterviewColoumnFromType(type)}
            tableData={data.data || []}
            Filters={
              <div className="w-full flex justify-start gap-4">
                <div>
                  <div className="text-sm font-semibold mb-1">Start Date</div>
                  <DatePickerWithoutStore
                    filterKey={FILTERSKEY.START_DATE + type}
                    placeholder="Start date"
                    value={startDateFilterKey[type]}
                    onChange={(date) => setStartDateFilterKey({...startDateFilterKey, [type]: date})}
                  />
                </div>
                <div className="">
                  <div className="text-sm font-semibold mb-1">End Date</div>
                  <DatePickerWithoutStore
                    filterKey={FILTERSKEY.END_DATE + type}
                    placeholder="End date"
                    value={endDateFilterKey[type]}
                    onChange={(date) => setEndDateFilterKey({...endDateFilterKey, [type]: date})}
                  />
                </div>
              </div>
            }
          />
        </div>

        <Pagination pageKey={FILTERSKEY.PAGINATION + type + startDateFilterKey[type]+endDateFilterKey[type]} totalPages={data.total_page} />
      </PageCard>
    </PageLayout>
  );
};

export default InterviewCredit;
